import { DealerID } from "./Dealer";

export type ReportTemplateID = number;

export enum REPORT_TEMPLATE_TYPES {
  Generic = 1,
  Communication = 2,
  Check = 3,
  MGCheck = 4
}

export interface ReportTemplate {
  created_on: string;
  updated_on: string;
  id: ReportTemplateID;
  name: string; // Name of this ReportTemplate
  description: string; // Describes what this ReportTemplate is for
  dealer_id: DealerID | null; // The DealerID this ReportTemplate was created for
  type: REPORT_TEMPLATE_TYPES; // The Type of ReportTemplate. It can be generic, communication, check or mg check
  is_previewable: boolean; // This ReportTemplate can be previewed before receiving the binary
}
